<form [formGroup]="summarizePage" id="summarize-page" (ngSubmit)=onSubmit(summarizePage)>
	<app-header></app-header>
	<div class="m-error pt-4" *ngIf="errorMessage">
		{{ errorMessage }}
	</div>
	<div class="d-flex flex-column justify-content-center">
		<div class="d-flex flex-column justify-content-center text-center container">
			<div class="m-4">
				<i class="img home-in-progress"></i>
			</div>
			<div *ngIf="!isAdvisor">
				<h3 class="h2">{{'SUMMARIZE.MSG_1_1'|translate:{name:user.firstName} }}</h3>
			</div>
			<div *ngIf="isAdvisor">
				<h3 class="h2">{{'SUMMARIZE.MSG_1_2'|translate:{name:user.firstName} }}</h3>
			</div>
			<div>{{'SUMMARIZE.MSG_2'|translate}}</div>
			<div *ngIf="cycleType==='outer'" class="bg-gray card py-2 mt-4">
				<!-- <h3 class="h3">{{'SUMMARIZE.TITLE_1'|translate}}</h3> -->

				<div class="my-2 d-flex justify-content-around flex-column flex-md-row">
					<div class="d-flex flex-row align-items-center1">
						<i class="img home-gray m-2"></i>
						<div class="text-right mt-3">
							<div class="m-lbl-summarize">{{'SUMMARIZE.LABEL_1'|translate}}</div>
							<div class="h4">{{user.propertyValue | currency:'₪':true:'1.0-0'}}</div>
						</div>
					</div>
					<div class="d-flex flex-row align-items-center1">
						<i class="img money m-2"></i>
						<div class="text-right mt-3">
							<div class="m-lbl-summarize">{{'SUMMARIZE.LABEL_2'|translate}}</div>
							<div class="h4">{{user.mortgageAmount | currency:'₪':true:'1.0-0'}}</div>
						</div>
					</div>
					<div class="d-flex flex-row align-items-center1">
						<i class="img calendar m-2"></i>
						<div class="text-right mt-3">
							<div class="m-lbl-summarize">{{'SUMMARIZE.LABEL_3'|translate}}</div>
							<div class="h4">{{user.monthlyRefundAmount | currency:'₪':true:'1.0-0'}}</div>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="cycleType==='inner'" class="bg-gray card py-2 mt-4">
				<!-- <h3 class="h3">{{'SUMMARIZE.TITLE_1'|translate}}</h3> -->

				<div class="my-2 d-flex justify-content-around flex-column flex-md-row">
					<div class="d-flex flex-row align-items-center1">
						<i class="img home-gray m-2"></i>
						<div class="text-right mt-3">
							<div class="m-lbl-summarize">{{'SUMMARIZE.LABEL_INNER_1'|translate}}</div>
							<div class="h4">{{user.cyclePurpose}}</div>
						</div>
					</div>
					<div class="d-flex flex-row align-items-center1">
						<i class="img money m-2"></i>
						<div class="text-right mt-3">
							<div class="m-lbl-summarize">{{'SUMMARIZE.LABEL_INNER_2'|translate}}</div>
							<div class="h4">{{user.cycleAmount | currency:'₪':true:'1.0-0'}}</div>
						</div>
					</div>
					<div class="d-flex flex-row align-items-center1">
						<i class="img calendar m-2"></i>
						<div class="text-right mt-3">
							<div class="m-lbl-summarize">{{'SUMMARIZE.LABEL_INNER_3'|translate}}</div>
							<div class="h4">{{user.internalAreCycleAllMorygage}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="my-4">
				<h3 class="h3">{{'SUMMARIZE.MSG_5'|translate}}</h3>
				<div class="my-2">{{'SUMMARIZE.MSG_6'|translate}}</div>
				<div>
					<textarea class="w-75 m-md-3 p-4" placeholder="{{'SUMMARIZE.PLACE_HOLDER'|translate}}"
						formControlName="textArea"></textarea>
				</div>
				<small class="m-error form-text" *ngIf="summarizePage.get('textArea').hasError('pattern')">
					{{ 'COMMON.NUM_LET_ONLY_PATTERN_ERROR' | translate }}
				</small>
				<small class="m-error form-text"
					*ngIf="summarizePage.get('textArea').hasError('maxlength') && !summarizePage.get('textArea').hasError('pattern')">
					{{ 'COMMON.TEXT_AREA_MAXLENGTH_ERROR' | translate }}
				</small>
				<!--CB-->
				<div *ngIf="!isAdvisor">
					<div class="form-check-title">{{'SUMMARIZE.CBOX_MARKETING_TTL'|translate}}</div>
					<div class="form-check custom-control custom-checkbox">
						<input class="custom-control-input" type="checkbox" value="isActive" (change)="cbChange()"
							formControlName="marketingCB" id="marketingCB">
						<label class="custom-control-label" for="marketingCB">
							{{'SUMMARIZE.CBOX_MARKETING'|translate}}
						</label>
					</div>
				</div>
				<!--BTN Submit-->
				<div *ngIf="isloading === false">
					<button type="submit" class="btn btn-primary m-2">{{'SUMMARIZE.BTN_SEND_LABEL'|translate}}</button>
				</div>
				<div *ngIf="isloading">
					<div class="loader"></div>
				</div>
			</div>
		</div>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/summarize-page/summarize-page.component.html